<script>
import classModifierMixin from './mixins/class-modifier-mixin'
export default {
	name: 'BaseRadio',
	mixins: [classModifierMixin],
	props: {
		label: {
			type: String,
			default: ''
		},
		value: {
			type: [ Boolean, String, Number ]
		},
        name: {
			type: String,
            default: ''
        }
	},
    computed: {
	    identifier: function () {
	    	return `${this.name}-${this.label}`
        }
    },
	methods: {
		updateValue (radioValue) {
			if (radioValue && radioValue !== undefined) this.$emit('input', radioValue)
		}
	}
}
</script>
<template>
	<div class="base-radio" :class="modifierClasses">
		<input class="base-radio__input"
               :name="name"
               :value="label"
               :id="identifier"
               type="radio"
               v-bind="$attrs"
               @input="updateValue(label)" >
		<label class="base-radio__label" :for="identifier">
			{{ label }}
		</label>
	</div>
</template>
<style lang="scss">
	.base-radio {
		display: flex;
		align-items: center;
		&__label {
			cursor: pointer;
			font-weight: var(--font-size-body-1);
			font-size: var(--font-size-body-1);
			padding-left: 0.5rem;
		}
		&--light-label {
			label {
				font-weight: var(--font-size-body-1);
				font-size: var(--font-size-body-1);
			}
		}
		&__input {
			cursor: pointer;
			padding: 0;
			margin: 0;
			&:disabled {
				background-color:#EEE;
				color:rgb(87,87,87);
			}
		}
	}
</style>
